import React, {Component} from "react";
import {
  salesPopDashboardUrl,
  currencyConvertDashboardUrl,
  emailWithLoveDashboardUrl,
  fbChatBoxDashboardUrl
} from '../config';
import {DisplayText, Button} from '@shopify/polaris';

class ListApp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listApps: [
        {
          appName: 'Currency Converter Box',
          appIcon: 'https://apps.shopifycdn.com/listing_images/2eb8bf799c282c87d7937f6a8e61e796/icon/70a11abb5171175a5cb0b22279355e7a.png?height=144&width=144%202x,%20https://apps.shopifycdn.com/listing_images/2eb8bf799c282c87d7937f6a8e61e796/icon/70a11abb5171175a5cb0b22279355e7a.png',
          price: 'Free',
          description: 'Automatically convert all currencies in the world',
          dashboardUrl: `${currencyConvertDashboardUrl}?shop=${this.props.shop}`,
          listingPageUrl: 'https://apps.shopify.com/currency-converter-master'
        },
        {
          appName: 'Sales Pop Master',
          appIcon: 'https://apps.shopifycdn.com/listing_images/18d54dc3ff21731dc43145d85b05aeec/icon/25151d6e50dbcec07442186d85648977.png',
          price: 'Free',
          description: 'Automatically show recent transaction, boost customer shopping',
          dashboardUrl: `${salesPopDashboardUrl}?shop=${this.props.shop}`,
          listingPageUrl: 'https://apps.shopify.com/sales-pop-master'
        },
        {
          appName: 'Email With Love',
          appIcon: 'https://apps.shopifycdn.com/listing_images/7c320a641c5173b8b4fdda076318a836/icon/eb8d6fd691c55e91db1e37d0d3d23d69.png',
          price: 'Free',
          description: 'Automated thank-you email to customers',
          dashboardUrl: `${emailWithLoveDashboardUrl}?shop=${this.props.shop}`,
          listingPageUrl: 'https://apps.shopify.com/email-with-love'
        },
        {
          appName: 'Facebook Chat Box',
          appIcon: 'https://apps.shopifycdn.com/listing_images/af9c031fdb1813a12cd313ef0421a3fb/icon/ec67dba40b382a8a7ddc5fb49dbfbc7c.png?height=168&width=168%202x,%20https://apps.shopifycdn.com/listing_images/af9c031fdb1813a12cd313ef0421a3fb/icon/ec67dba40b382a8a7ddc5fb49dbfbc7c.png?height=84&width=84%201x',
          price: 'Free',
          description: 'Live chat with customers via Facebook Messenger',
          dashboardUrl: `${fbChatBoxDashboardUrl}?shop=${this.props.shop}`,
          listingPageUrl: 'https://apps.shopify.com/facebook-chat-box'
        },
        {
          appName: 'Discount Master',
          appIcon: 'https://apps.shopifycdn.com/listing_images/f0d5c01083c0e2ebb750b334c88b548b/icon/eb47cc2049568cc558bd4d789957046b.png?height=168&width=168%202x,%20https://apps.shopifycdn.com/listing_images/f0d5c01083c0e2ebb750b334c88b548b/icon/eb47cc2049568cc558bd4d789957046b.png?height=84&width=84%201x',
          price: 'Free plan available',
          description: 'Establish automatic discount campaigns to boost sales',
          dashboardUrl: '',
          listingPageUrl: 'https://apps.shopify.com/discount-master'
        }
      ]
    }
  }

  appCrossSellTrack = app => {
    window.mixpanel.track(`${this.props.appCode} cross sell footer to app: ${app}`);
  };

  render() {
    const appName = this.props.appName;
    let appSelected;

    switch (appName) {
      case 'currency':
        appSelected = this.state.listApps[0];
        break;
      case 'sales-pop':
        appSelected = this.state.listApps[1];
        break;
      case 'email-with-love':
        appSelected = this.state.listApps[2];
        break;
      case 'facebook-chat':
        appSelected = this.state.listApps[3];
        break;
      case 'discount-master':
        appSelected = this.state.listApps[4];
        break;
      default:
        break;
    }

    const listingPageUrl =  `${appSelected.listingPageUrl}?utm_source=in_app_admin&utm_medium=${appName}`;

    return (
      <div className="col-md-4">
        <a target="_blank" className="wrap-app-link-name" href={listingPageUrl}>
          <div className="wrap-icon-app">
            <img src={appSelected.appIcon}/>
          </div>
          <div className="wrap-app-info">
            <span className="app-name">{appSelected.appName}</span>
            <span className="price">{appSelected.price}</span>
            <span className="description">{appSelected.description}</span>
          </div>
          <div className="clearfix"/>
        </a>
      </div>

    )
  }
}

export default ListApp
